/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import { fetchGraphQL, getVariables } from '../helpers/dataHelpers';

import {
  QUERY_TRANSACTIONS,
  QUERY_USER_TRANSACTIONS,
} from '../graphql/transactions';
import apolloClient from '../services/apollo-client';
import userAccount from '../models/userAccount';

const transactionsProvider = {
  getList: async (resource, params) =>
    fetchGraphQL(QUERY_TRANSACTIONS, resource, params),

  getOne: async (resource, params) => {
    const variables = getVariables(resource, params);
    const response = await apolloClient.query({
      query: QUERY_USER_TRANSACTIONS,
      variables: {
        ...variables,
        userId: params.id,
        filters: { ...variables.filters, userId: params.id },
      },
    });
    return {
      data: userAccount({ ...response.data.userAccount, id: params.id }),
    };
  },

  getMany: async (resource, params) => Promise,

  getManyReference: (resource, params) => Promise,

  create: async (resource, params) => Promise,

  update: async (resource, params) => Promise,

  updateMany: async (resource, params) => Promise,

  delete: (resource, params) => Promise,

  deleteMany: (resource, params) => Promise,
};

export default transactionsProvider;
